/* eslint-disable */
import { register } from '../../../../Javascript/Sysmex/Utils'

const GlobalLoader = el => {
  const prefix = el.dataset.prefix

  window.showGlobalLoader = new CustomEvent("changeGlobalLoader", { detail: { show: true} })
  window.hideGlobalLoader = new CustomEvent("changeGlobalLoader", { detail: { show: false} })

  window.addEventListener("changeGlobalLoader", e => el.classList.toggle(`${prefix}is--visible`, e.detail.show))
}

register('GlobalLoader', GlobalLoader)
